import { render, staticRenderFns } from "./BalanceRecordsTab.vue?vue&type=template&id=69f72b6a"
import script from "./BalanceRecordsTab.vue?vue&type=script&lang=js"
export * from "./BalanceRecordsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports